import { CustomButton, CustomTextInput } from "@Modules/core/components";
import CustomFormControl from "@Modules/core/components/form/CustomFormControl";
import { ICurrencyDefinitionFormMeta } from '@Modules/admin/basicSettings/containers/formHandlers/center/currency/currencyDefinition/CurrencyDefinitionMeta';
import { ChakraComponents as CC } from "@Modules/core/lib/chakra";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { FaSave } from "react-icons/fa";

let itemsList = [
    { 
        association: 'association 1', 
        nom: 'nom 1',
        decimale: '0',
    },
    { 
        association: 'association 2', 
        nom: 'nom 2',
        decimale: '0',
    },
    { 
        association: 'association 3', 
        nom: 'nom 3',
        decimale: '0',
    },
  ]

type Props = {
  onSubmit: any,
  meta: ICurrencyDefinitionFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
} 

const CurrencyDefinitionFormUI = ({onSubmit, isLoading, isSubmitting, meta}: Props) => {

    const {
        register,
        handleSubmit,
        formState: { errors },
        // reset,
      } = useForm({ resolver: yupResolver(meta.schema),});
    
  return (
    <>
        <CC.Heading as='h1' size={'md'} fontWeight="Bold" mb={'10'}>
            Devise
        </CC.Heading>
        <CC.Box w={'100%'} as={"form"} onSubmit={handleSubmit(onSubmit)}>
            <CC.Card p={5} mb={10}>
                <CC.Grid templateColumns={{base: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', md: 'repeat(2, 1fr)', lg: 'repeat(4, 1fr)'}} gap={5}>
                    <CustomFormControl
                        label={meta.myId.label}
                        isLoading={isLoading}
                        isInvalid={!!errors[meta.myId.name]}
                    >
                        <CustomTextInput meta={meta.myId}  register={register(meta.myId.name)} hasError={errors[meta.myId.name]} />
                    </CustomFormControl> 
                    <CustomFormControl
                        label={meta.name.label}
                        isLoading={isLoading}
                        isInvalid={!!errors[meta.name.name]}
                    >
                        <CustomTextInput meta={meta.name}  register={register(meta.name.name)} hasError={errors[meta.name.name]} />
                    </CustomFormControl>
                <CustomFormControl
                        label={meta.symbol.label}
                        isLoading={isLoading}
                        isInvalid={!!errors[meta.symbol.name]}
                    >
                    <CustomTextInput meta={meta.symbol}  register={register(meta.symbol.name)} hasError={errors[meta.symbol.name]} />
                </CustomFormControl>
                <CustomFormControl
                        label={meta.alphaCode.label}
                        isLoading={isLoading}
                        isInvalid={!!errors[meta.alphaCode.name]}
                    >
                    <CustomTextInput meta={meta.alphaCode}  register={register(meta.alphaCode.name)} hasError={errors[meta.alphaCode.name]} />
                </CustomFormControl>
                </CC.Grid>
            </CC.Card>

            {/* <CC.TableContainer>
                <CC.Table variant='striped'>
                    <CC.Thead>
                        <CC.Tr>
                        <CC.Th>Association</CC.Th>
                        <CC.Th>Nom</CC.Th>
                        <CC.Th>Decimal</CC.Th>
                        </CC.Tr>
                    </CC.Thead>
                    <CC.Tbody>
                        {itemsList.map((elt, index) => (
                        <CC.Tr key={index}>
                            <CC.Td>
                                {elt.association}
                            </CC.Td>
                            <CC.Td>
                                {elt.nom}
                            </CC.Td>
                            <CC.Td>
                                {elt.decimale}
                            </CC.Td>
                        </CC.Tr>
                        ))}            
                    </CC.Tbody>
                </CC.Table>
            </CC.TableContainer> */}

            

            <CC.HStack my={6} justifyContent={'flex-end'}>
                <CustomButton isLoading={isSubmitting} type={"submit"}><FaSave style={{marginRight: '10px'}} /> Enregistrer</CustomButton>
            </CC.HStack>

        </CC.Box>
    </>    
  )
}

export default CurrencyDefinitionFormUI;